@import "https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,400;0,700;1,400&display=swap";

/* src/app/login/login-novo.component.scss */
:root {
  --azul1:
    30,
    66,
    139;
  --azul2:
    0,
    111,
    185;
  --azul4:
    0,
    82,
    135;
  --verde2:
    101,
    179,
    46;
  --preto:
    0,
    0,
    0;
  --branco:
    255,
    255,
    255;
}
*,
*::after,
*::before {
  box-sizing: border-box;
}
*:focus {
  outline: none;
}
html {
  font-size: 16px;
  height: 100%;
}
body {
  margin: 0;
  height: 100%;
  font-family: "Fira Sans", sans-serif;
}
textarea,
input[type=text],
input[type=password],
input[type=button] {
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 0;
  border: none;
  background-color: transparent;
}
input[type=text],
input[type=password] {
  font-size: 1rem;
  margin-top: 1rem;
  border-bottom: 1px solid;
}
label {
  display: block;
  margin-top: 2rem;
}
label span,
label input {
  font-size: 1.2rem;
  display: block;
  width: 100%;
}
.bg {
  position: fixed;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  left: 0px;
}
.bg1 {
  background-image: url("./media/01.jpg");
}
.bg2 {
  background-image: url("./media/02.jpg");
}
.bg3 {
  background-image: url("./media/03.jpg");
}
.bg4 {
  background-image: url("./media/04.jpg");
}
.bg::before {
  content: "";
  position: absolute;
  display: block;
  height: 100%;
  width: 500px;
  background-image:
    linear-gradient(
      90deg,
      black,
      rgba(0, 0, 0, 0));
}
.saudacao {
  margin: 0;
  font-size: 2.5rem;
  line-height: 1.25;
  color: white;
  position: inherit;
  top: 50%;
  transform: translateY(-50%);
  left: 80px;
  z-index: 1;
  font-weight: normal;
}
.saudacao strong {
  text-transform: uppercase;
}
.form {
  overflow: hidden;
  color: white;
  position: absolute;
  right: 0;
  height: 100%;
  width: 40%;
  min-width: 564px;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form::before {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgb(0, 111, 185);
  mix-blend-mode: multiply;
}
.triangulo {
  position: absolute;
  width: 200%;
  height: 50%;
}
.elemento-grafico {
  position: absolute;
}
.triangulo-topo {
  top: 0;
  fill: rgb(30, 66, 139);
  mix-blend-mode: multiply;
}
.triangulo-base {
  bottom: 0;
  fill: rgb(101, 179, 46);
  mix-blend-mode: multiply;
}
.circulo {
  width: 33.3333333333%;
  bottom: 0;
  right: 0;
  fill: rgb(0, 82, 135);
  mix-blend-mode: multiply;
}
.form__itens {
  width: 100%;
  max-width: 564px;
  padding: 0 32px;
  margin: auto;
  position: relative;
  z-index: 1;
}
.logo {
  display: block;
  width: 200px;
  margin-bottom: 40px;
  height: auto;
}
.esqueci-senha {
  margin: 1rem 0;
  font-size: 1rem;
}
.esqueci-senha a {
  color: white;
  text-decoration: underline;
}
.esqueci-senha a:hover {
  text-decoration: none;
}
.btns {
  margin-top: 2rem;
  text-align: center;
  display: grid;
  grid-template-columns: 2fr 1fr 2fr;
}
.btns .btn {
  font-weight: bold;
  cursor: pointer;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  color: rgb(30, 66, 139);
  background-color: white;
  transition: 0.2s;
}
.btns .btn:hover {
  background-color: rgba(255, 255, 255, 0.7);
}
.btns .btn:focus {
  background-color: rgba(255, 255, 255, 0.7);
}
.btns span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.btns a {
  display: inline-block;
  font-size: 1rem;
  text-decoration: none;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: white !important;
  border-bottom-color: white;
}
.bn-loading-in-button {
  color: rgb(30, 66, 139);
}
.invalid-feedback span {
  color: #ffdc95;
  font-size: 0.95rem !important;
}
.ng-invalid.ng-touched ~ .invalid-feedback {
  display: block;
}
@media (max-width: 1200px) {
  .form {
    min-width: 430px;
    font-size: 1.125rem;
  }
  .saudacao {
    left: 40px;
  }
  .bg4 {
    height: 100%;
  }
}
@media (max-width: 860px) {
  .form {
    min-width: unset;
  }
  .form__itens {
    padding: 0 20px;
  }
  .btns {
    display: block;
  }
  .btns .btn {
    font-size: 1rem;
    width: 100%;
    display: block;
  }
  .btns span {
    margin: 0.5rem 0;
  }
  .btns a br {
    display: none;
  }
  .bg4 {
    height: 100%;
  }
}
@media (max-width: 700px) {
  html {
    margin-top: -1.5rem;
    margin-left: 0;
  }
  body {
    height: unset;
    min-height: 100%;
    background-color: rgb(30, 66, 139);
  }
  .wrapper {
    display: block;
  }
  .bg {
    position: relative;
    height: 100%;
  }
  .bg::before {
    width: 100%;
    background-image:
      linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.5),
        rgba(0, 0, 0, 0));
  }
  .form {
    position: relative;
    font-size: 1rem;
    height: unset;
    left: 0;
    width: 100%;
    bottom: 0;
    background-color: rgb(30, 66, 139);
    z-index: 1;
  }
  .form::before {
    display: none;
  }
  .form__itens {
    max-width: unset;
    padding: 100px 20px;
  }
  .saudacao {
    top: unset;
    bottom: 1rem;
    left: 1rem;
    width: calc(100% - 2rem);
    transform: none;
  }
  label {
    margin-top: 1rem;
  }
  .btns {
    display: grid;
    grid-template-columns: 1fr 50px 1fr;
  }
}
@media (max-width: 500px) {
  .logo {
    width: 150px;
    margin-bottom: 35px;
  }
  .form__itens {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .btns {
    display: block;
  }
  .saudacao {
    font-size: 1.75rem;
    height: 100%;
  }
  .bg4 {
    height: 100%;
  }
}
/*# sourceMappingURL=login-novo.component.css.map */
